import React, { useContext, useEffect, useState } from 'react'
import style from "../../../../../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import globalStyles from "../../../../../../assets/styles/global.module.scss";
import integrationStyles from "../../../../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import { Autocomplete, Divider, Grid, TextField, Typography } from '@mui/material';
import { IntegrationContext, IntegrationContextPayload } from '../../../../../../context/integrationContext';
import { ContactContext, ContactContextPayload } from '../../../../../../context/contactContext';
import { UserContext, UserContextPayload } from '../../../../../../context/userContext';
import { addContactChatbotAssignmentPayload, campaignContact, chatbotListInterface, getCampaignContactListResponse, getCampaignContactResponse, metaIntegrationFaceBookDataNew, metaIntegrationPhoneNumberDataNew, metaIntegrationWhatsAppDataNew, metIntegrationInstagramDataNew } from '../../../../../../models/axiosModel';
import { useSearchParams } from 'react-router-dom';
import Required from '../../../../../utility/required';
import { ChatbotContext, ChatbotContextPayload } from '../../../../../../context/chatbotContext';
import GlobalButton from '../../../../../utility/globalButton/button';
import agent from '../../../../../../services/api';
import { getEmptyAssignContactRecipientPayload } from '../whatsAppIntegrationConstant';
import { useGenericStore } from '../../../../../../store/genericStore';
import { useShallow } from 'zustand/react/shallow';
import { filterOutArchivedContactLists } from '../../../../contacts/contactConstant';

interface AssignCustomRecipientPopupProps {
    setFlagOpenAssignContactPopup: React.Dispatch<React.SetStateAction<boolean>>,
    getmetaIntegrationList: () => Promise<void>,
} 

const AssignCustomRecipientPopup: React.FC<AssignCustomRecipientPopupProps> = (props) => {

    const { setFlagOpenAssignContactPopup, getmetaIntegrationList } = props;
    const { integrationList, globalIntegrationTypeList, integrationListNewStructure } = useContext(IntegrationContext) as IntegrationContextPayload;
    const { getCampaignContactListApi, campaignContactListData, getCampaignContactApi, filteredCampaignContactData } = useContext(ContactContext) as ContactContextPayload; 
    const { setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;
    const { GetChatbotListApi, chatbotList } = useContext(ChatbotContext) as ChatbotContextPayload;

    const { showSuccess } = useGenericStore(useShallow((state) => ({
        showSuccess: state.showSuccess
    })))

    const [searchParams] = useSearchParams();
    const id = searchParams.get('id');
    const phoneNumberId = searchParams.get('phonenumberId');
    

    const [assignCustomRecipientPayload, setAssignCustomRecipientPayload] = useState<addContactChatbotAssignmentPayload>(
        getEmptyAssignContactRecipientPayload(integrationList?.[0]?.channel_authoriser_user_data_id || 0, globalIntegrationTypeList?.find((type) => type.channel_name.toLowerCase() == "whatsapp")?.channel_id || 1, integrationListNewStructure, id, phoneNumberId)
    );

    const getCampaignContactList = async () => {
        setFlagLoading((prev) => ({...prev, flagRoundLoader: true}));
        const res = await getCampaignContactListApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({...prev, flagRoundLoader: false}));
    }

    const getCampaignContact = async (list_id: number) => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const payload = {
            contact_list_id: list_id,
        }
        const res = await getCampaignContactApi(payload);
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const getChatbotListApiCall = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await GetChatbotListApi();
        if(!(res.status)){
            handleError(res);
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    const onChangeOfContactList = (value: getCampaignContactListResponse | null) => {
        setAssignCustomRecipientPayload((prev) => ({
            ...prev, 
            contact_list_id: value ? value.contact_list_id : 0,
        })); 

        if(value){
            getCampaignContact(value.contact_list_id);
        }
    } 

    const getOptionLabelOfCampaignContact = (option: campaignContact) => {
        const firstName = option.contact_data?.find((data) => data.contact_field_name.toLowerCase() == "first name")?.contact_data_value;
        const lastName = option.contact_data?.find((data) => data.contact_field_name.toLowerCase() == "last name")?.contact_data_value;
        const phoneNumber =  option.contact_data?.find((data) => data.contact_field_name.toLowerCase() == "phone number")?.contact_data_value || "";

        if(firstName && !lastName){
            return `${phoneNumber} (${firstName})`;
        } else if(!firstName && lastName){
            return `${phoneNumber} (${lastName})`;
        } else if(firstName && lastName){
            return `${phoneNumber} (${firstName} ${lastName})`
        } else return phoneNumber;
    }

    const checkDisabledAssignBtn = () => {
        if(assignCustomRecipientPayload.chatbot_id == 0 || assignCustomRecipientPayload.contact_id[0] == 0 || assignCustomRecipientPayload.contact_list_id == 0){
            return true;
        }
        return false;
    }

    const handleAssignClick = async () => {
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: true }));
        const res = await agent.addContactChatbotAssignment.post(assignCustomRecipientPayload);
        if(!(res.status)){
            handleError(res);
        } else {
            showSuccess("Custom Recipient Assigned Successfully.")
            setFlagOpenAssignContactPopup(false);
            await getmetaIntegrationList(); // GET Call.
        }
        setFlagLoading((prev) => ({ ...prev, flagRoundLoader: false }));
    }

    useEffect(() => {
        if(!campaignContactListData){
            getCampaignContactList();
        }
        if(!chatbotList){
            getChatbotListApiCall();
        }
    }, []);

    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={`${globalStyles.flexColumn} ${globalStyles.justifyCenter}`}>
                        <Grid item className={globalStyles.textCenter}>
                            <Typography className={style.popupTitleTypography}> {`Assign Custom Recipient`}</Typography>
                        </Grid>

                        <Divider className={style.popupTitleDivider} />

                        <Grid item>
                            <Grid container className={style.popupBodyGridContainer} gap={2}>
                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Contact List <Required /></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                className={`${style.contactFilterDropDowns} ${style.contactFilterDropdownsInPopup}`}
                                                options={filterOutArchivedContactLists(campaignContactListData) || []}
                                                getOptionLabel={(option: getCampaignContactListResponse) => option.contact_list_name || ""}
                                                value={campaignContactListData?.find((list: getCampaignContactListResponse) => list.contact_list_id == assignCustomRecipientPayload.contact_list_id) || null}
                                                onChange={(_: React.SyntheticEvent, value: getCampaignContactListResponse | null) => onChangeOfContactList(value)}
                                                renderInput={(params) => <TextField {...params} placeholder='Select Contact List' />}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                
                                {assignCustomRecipientPayload.contact_list_id != 0 && 
                                    <Grid item xs={12}>
                                        <Grid container gap={"12px"}>
                                            <Grid item xs={12}>
                                                <Typography className={style.popupFieldTypography}>Contact <Required /></Typography>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Autocomplete
                                                    className={`${style.contactFilterDropDowns} ${style.contactFilterDropdownsInPopup}`}
                                                    options={filteredCampaignContactData?.[0]?.contact || []}
                                                    getOptionLabel={(option: campaignContact) => getOptionLabelOfCampaignContact(option)}
                                                    value={filteredCampaignContactData?.[0]?.contact?.find((data) => data.contact_id == assignCustomRecipientPayload.contact_id[0]) || null}
                                                    onChange={(_: React.SyntheticEvent, value: campaignContact | null) => {
                                                        setAssignCustomRecipientPayload((prev) => ({
                                                            ...prev, 
                                                            contact_id: value ? [value.contact_id] : [0],
                                                        }));
                                                    }}
                                                    renderInput={(params) => <TextField {...params} placeholder='Select Contact' />}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                }

                                <Grid item xs={12}>
                                    <Grid container gap={"12px"}>
                                        <Grid item xs={12}>
                                            <Typography className={style.popupFieldTypography}>Chatbot <Required /></Typography>
                                        </Grid>
                                        <Grid item xs={12}>
                                            <Autocomplete
                                                className={`${style.contactFilterDropDowns} ${style.contactFilterDropdownsInPopup}`}
                                                options={chatbotList || []}
                                                getOptionLabel={(option: chatbotListInterface) => option.chatbot_name || ""}
                                                value={chatbotList?.find((chatbot) => chatbot.chatbot_id == String(assignCustomRecipientPayload.chatbot_id)) || null}
                                                onChange={(_: React.SyntheticEvent, value: chatbotListInterface | null) => {
                                                    setAssignCustomRecipientPayload((prev) => ({
                                                        ...prev, 
                                                        chatbot_id: value ? Number(value.chatbot_id) : 0,
                                                    }));
                                                }}
                                                renderInput={(params) => <TextField {...params} placeholder='Select Chatbot' />}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                
                                <Grid item xs={12}>
                                    <Grid container className={`${globalStyles.justifyCenter} ${globalStyles.alignItemCenter} ${integrationStyles.assignCusonRecippientBtnGrp}`} gap={"12px"}>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Cancel"
                                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                className='borderedButtonStyle'
                                                onClick={() => {
                                                    setFlagOpenAssignContactPopup(false);
                                                }}
                                            >
                                            </GlobalButton>
                                        </Grid>
                                        <Grid item>
                                            <GlobalButton
                                                buttonText="Assign"
                                                sx={{ width: "130px", padding: "6.5px 20px !important", fontWeight: "500 !important" }}
                                                className='primaryButtonStyle'
                                                disabled={checkDisabledAssignBtn()}
                                                onClick={() => handleAssignClick()}
                                            >
                                            </GlobalButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default AssignCustomRecipientPopup
